import Cover from './cover.jpeg'
import Hero from './3.jpeg'
import Image1 from './1.jpeg'
import Image2 from './2.jpeg'
import Image3 from './3.jpeg'
import Image4 from './4.jpeg'
import Image5 from './5.jpeg'
import Image6 from './6.jpeg'
import Image7 from './7.jpeg'
import Image8 from './8.jpeg'
import Image9 from './9.jpeg'
import Image10 from './10.jpeg'
import Image11 from './11.jpeg'
import Image12 from './12.jpeg'
import Image13 from './13.jpeg'
import Image14 from './14.jpeg'
import Image15 from './15.jpeg'
import Image16 from './16.jpeg'
import Image17 from './17.jpeg'
import Image18 from './18.jpeg'
import Image19 from './19.jpeg'
import Image20 from './20.jpeg'
import Image21 from './21.jpeg'
import Image22 from './22.jpeg'
import Image23 from './23.jpeg'
import Image24 from './24.jpeg'
import Image25 from './25.jpeg'
import Image26 from './26.jpeg'
import Image27 from './27.jpeg'
import Image28 from './28.jpeg'
import Image29 from './29.jpeg'
import Image30 from './30.jpeg'
import Image31 from './31.jpeg'
import Image32 from './32.jpeg'
import Image33 from './33.jpeg'
import Image34 from './34.jpeg'
import Image35 from './35.jpeg'
import Image36 from './36.jpeg'
import Image37 from './37.jpeg'
import Image38 from './38.jpeg'
import Image39 from './39.jpeg'
import Image40 from './40.jpeg'
import Image41 from './41.jpeg'
import Image42 from './42.jpeg'
import Image43 from './43.jpeg'
import Image44 from './44.jpeg'
import Image45 from './45.jpeg'
import Image46 from './46.jpeg'
import Image47 from './47.jpeg'
import Image48 from './48.jpeg'
import Image49 from './49.jpeg'
import Image50 from './50.jpeg'
import Image51 from './51.jpeg'
import Image52 from './52.jpeg'
import Image53 from './53.jpeg'
import Image54 from './54.jpeg'
import Image55 from './55.jpeg'
import Image56 from './56.jpeg'
import Image57 from './57.jpeg'
import Image58 from './58.jpeg'
import Image59 from './59.jpeg'
import Image60 from './60.jpeg'
import Image61 from './61.jpeg'
import Image62 from './62.jpeg'
import Image63 from './63.jpeg'
import Image64 from './64.jpeg'
import Image65 from './65.jpeg'
import Image66 from './66.jpeg'
import Image67 from './67.jpeg'
import Image68 from './68.jpeg'
import Image69 from './69.jpeg'
import Image70 from './70.jpeg'
import Image71 from './71.jpeg'
import Thumbnail1 from './1t.jpg'
import Thumbnail2 from './2t.jpg'
import Thumbnail3 from './3t.jpg'
import Thumbnail4 from './4t.jpg'
import Thumbnail5 from './5t.jpg'
import Thumbnail6 from './6t.jpg'
import Thumbnail7 from './7t.jpg'
import Thumbnail8 from './8t.jpg'
import Thumbnail9 from './9t.jpg'
import Thumbnail10 from './10t.jpg'
import Thumbnail11 from './11t.jpg'
import Thumbnail12 from './12t.jpg'
import Thumbnail13 from './13t.jpg'
import Thumbnail14 from './14t.jpg'
import Thumbnail15 from './15t.jpg'
import Thumbnail16 from './16t.jpg'
import Thumbnail17 from './17t.jpg'
import Thumbnail18 from './18t.jpg'
import Thumbnail19 from './19t.jpg'
import Thumbnail20 from './20t.jpg'
import Thumbnail21 from './21t.jpg'
import Thumbnail22 from './22t.jpg'
import Thumbnail23 from './23t.jpg'
import Thumbnail24 from './24t.jpg'
import Thumbnail25 from './25t.jpg'
import Thumbnail26 from './26t.jpg'
import Thumbnail27 from './27t.jpg'
import Thumbnail28 from './28t.jpg'
import Thumbnail29 from './29t.jpg'
import Thumbnail30 from './30t.jpg'
import Thumbnail31 from './31t.jpg'
import Thumbnail32 from './32t.jpg'
import Thumbnail33 from './33t.jpg'
import Thumbnail34 from './34t.jpg'
import Thumbnail35 from './35t.jpg'
import Thumbnail36 from './36t.jpg'
import Thumbnail37 from './37t.jpg'
import Thumbnail38 from './38t.jpg'
import Thumbnail39 from './39t.jpg'
import Thumbnail40 from './40t.jpg'
import Thumbnail41 from './41t.jpg'
import Thumbnail42 from './42t.jpg'
import Thumbnail43 from './43t.jpg'
import Thumbnail44 from './44t.jpg'
import Thumbnail45 from './45t.jpg'
import Thumbnail46 from './46t.jpg'
import Thumbnail47 from './47t.jpg'
import Thumbnail48 from './48t.jpg'
import Thumbnail49 from './49t.jpg'
import Thumbnail50 from './50t.jpg'
import Thumbnail51 from './51t.jpg'
import Thumbnail52 from './52t.jpg'
import Thumbnail53 from './53t.jpg'
import Thumbnail54 from './54t.jpg'
import Thumbnail55 from './55t.jpg'
import Thumbnail56 from './56t.jpg'
import Thumbnail57 from './57t.jpg'
import Thumbnail58 from './58t.jpg'
import Thumbnail59 from './59t.jpg'
import Thumbnail60 from './60t.jpg'
import Thumbnail61 from './61t.jpg'
import Thumbnail62 from './62t.jpg'
import Thumbnail63 from './63t.jpg'
import Thumbnail64 from './64t.jpg'
import Thumbnail65 from './65t.jpg'
import Thumbnail66 from './66t.jpg'
import Thumbnail67 from './67t.jpg'
import Thumbnail68 from './68t.jpg'
import Thumbnail69 from './69t.jpg'
import Thumbnail70 from './70t.jpg'
import Thumbnail71 from './71t.jpg'

export {
  Cover,
  Hero,
  Image1,
  Image2,
  Image3,
  Image4,
  Image5,
  Image6,
  Image7,
  Image8,
  Image9,
  Image10,
  Image11,
  Image12,
  Image13,
  Image14,
  Image15,
  Image16,
  Image17,
  Image18,
  Image19,
  Image20,
  Image21,
  Image22,
  Image23,
  Image24,
  Image25,
  Image26,
  Image27,
  Image28,
  Image29,
  Image30,
  Image31,
  Image32,
  Image33,
  Image34,
  Image35,
  Image36,
  Image37,
  Image38,
  Image39,
  Image40,
  Image41,
  Image42,
  Image43,
  Image44,
  Image45,
  Image46,
  Image47,
  Image48,
  Image49,
  Image50,
  Image51,
  Image52,
  Image53,
  Image54,
  Image55,
  Image56,
  Image57,
  Image58,
  Image59,
  Image60,
  Image61,
  Image62,
  Image63,
  Image64,
  Image65,
  Image66,
  Image67,
  Image68,
  Image69,
  Image70,
  Image71,
  Thumbnail1,
  Thumbnail2,
  Thumbnail3,
  Thumbnail4,
  Thumbnail5,
  Thumbnail6,
  Thumbnail7,
  Thumbnail8,
  Thumbnail9,
  Thumbnail10,
  Thumbnail11,
  Thumbnail12,
  Thumbnail13,
  Thumbnail14,
  Thumbnail15,
  Thumbnail16,
  Thumbnail17,
  Thumbnail18,
  Thumbnail19,
  Thumbnail20,
  Thumbnail21,
  Thumbnail22,
  Thumbnail23,
  Thumbnail24,
  Thumbnail25,
  Thumbnail26,
  Thumbnail27,
  Thumbnail28,
  Thumbnail29,
  Thumbnail30,
  Thumbnail31,
  Thumbnail32,
  Thumbnail33,
  Thumbnail34,
  Thumbnail35,
  Thumbnail36,
  Thumbnail37,
  Thumbnail38,
  Thumbnail39,
  Thumbnail40,
  Thumbnail41,
  Thumbnail42,
  Thumbnail43,
  Thumbnail44,
  Thumbnail45,
  Thumbnail46,
  Thumbnail47,
  Thumbnail48,
  Thumbnail49,
  Thumbnail50,
  Thumbnail51,
  Thumbnail52,
  Thumbnail53,
  Thumbnail54,
  Thumbnail55,
  Thumbnail56,
  Thumbnail57,
  Thumbnail58,
  Thumbnail59,
  Thumbnail60,
  Thumbnail61,
  Thumbnail62,
  Thumbnail63,
  Thumbnail64,
  Thumbnail65,
  Thumbnail66,
  Thumbnail67,
  Thumbnail68,
  Thumbnail69,
  Thumbnail70,
  Thumbnail71,
}
